angular.module('impactx.message').controller('MessageReplyCtrl', MessageReplyCtrl);

MessageReplyCtrl.$inject = ['$scope', '$controller'];

function MessageReplyCtrl($scope, $controller) {

    $scope.forReply = true; // just to tell the detail ctrl to call the answer entry point directly 
    angular.extend(this, $controller('MessageDetailCtrl', {$scope: $scope}));
}